import {http} from '@/http/ai-plugin-http'
import {GlxBaseDto} from '@/ai-plugin-api/type'
import {AiMessageRoleEnum} from '@/ai-plugin-api/type-ai'
import {HistoryDto, HistoryPageForm} from '@/ai-plugin-api/historyApi'

export type HistoryTextPageForm = HistoryPageForm & {
    textUtilId?: number
}

export type HistoryTextRecentForm = Pick<
    HistoryTextPageForm,
    'clientId' | 'model' | 'utilType' | 'textUtilId' | 'size'
>

export type HistoryTextDto = {
    textUtilId: number

    round: {
        question: HistoryTextMessage
        answer?: HistoryTextMessage
    }
    history: HistoryDto
} & GlxBaseDto

export type HistoryTextMessage = {
    role: AiMessageRoleEnum
    reasoning?: string
    content: string
}

export type HistoryTextDtoPartial = Pick<HistoryTextDto, 'round'> & Partial<Omit<HistoryTextDto, 'round'>>

export async function recentList(params: HistoryTextRecentForm) {
    return http.glxGet<HistoryTextDto[]>('/history-text/recent', {
        params
    })
}
